import script from "./PlanInvoices.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanInvoices.vue?vue&type=script&setup=true&lang=js"

import "./PlanInvoices.vue?vue&type=style&index=0&id=60c79ea4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60c79ea4"]])

export default __exports__